import React from "react";
import Home from "../pages/Home";
import AllCategories from "../pages/AllCategories";
import AllBrands from "../pages/AllBrands";
import AllProducts from "../pages/AllProducts";
import Footer from "../components/Footer";
import Header from "../components/Header";
import WishList from "../pages/WishList";
import UploadPrescription from "../pages/UploadPrescription";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Login from "../pages/Login";
import User from "../pages/User";
import Orders from "../components/User/Orders";
import Profile from "../components/User/Profile";
import PrivateRoute from "./PrivateRoute";
import OrderDetails from "../components/User/OrderDetails";
import AllAddress from "../components/User/AllAddress";
import CreateAddress from "../components/User/CreateAddress";
import UpdateAddress from "../components/User/UpdateAddress";
import ProductDetails from "../pages/ProductDetails";
import Cart from "../pages/Cart";
import EditProfile from "../components/User/EditProfile";
import AllFeaturedProducts from "../pages/AllFeaturedProducts";
import AllOfferrProducts from "../pages/AllOfferrProducts";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsConditions from "../pages/TermsConditions";
import ScrollWrapper from "./ScrollWrapper";
import InjectInterceptors from "./InjectInterceptors";

function Router() {
  return (
    <BrowserRouter>
    <ScrollWrapper>
    <div className="d-flex flex-column vh-100">
        <Header />
        <InjectInterceptors/>
        <div className="main-ecomm">
          <Routes>
            
            <Route exact path="/" element={<Home />} />
            <Route exact path="/categories" element={<AllCategories />} />
            <Route exact path="/brands" element={<AllBrands />} />
            <Route exact path="/featuredproducts" element={<AllFeaturedProducts />} />
            <Route exact path="/allofferrproducts" element={<AllOfferrProducts />} />
            <Route exact path="/wishlist" element={<PrivateRoute><WishList /></PrivateRoute>} />
            <Route exact path="/uploadprescription" element={<PrivateRoute><UploadPrescription /></PrivateRoute>} />
            <Route
              exact
              path="/products/category/:id"
              element={<AllProducts />}
            />
            <Route exact path="/products/brand/:id" element={<AllProducts />} />
            <Route exact path="/productDetails/:id" element={<ProductDetails />} />
            <Route exact path="/login" element={<Login />} />
            <Route exact path="/cart" element={<PrivateRoute><Cart /></PrivateRoute>} />

            <Route exact path="user" element={<PrivateRoute><User /></PrivateRoute>}>
              <Route exact path="orders" element={<PrivateRoute><Orders /></PrivateRoute>} />
              <Route exact path="orderdetails/:id" element={<PrivateRoute><OrderDetails /></PrivateRoute>} />
              <Route exact path="createAddress" element={<PrivateRoute><CreateAddress /></PrivateRoute>} />
              <Route exact path="updateAddress/:id" element={<PrivateRoute><UpdateAddress /></PrivateRoute>} />
              <Route exact path="address" element={<PrivateRoute><AllAddress /></PrivateRoute>} />
              <Route exact path="editprofile" element={<PrivateRoute><EditProfile /></PrivateRoute>} />
              <Route index exact element={<PrivateRoute><Profile /></PrivateRoute>} />
            </Route>
            <Route exact path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route exact path="/termsconditions" element={<TermsConditions />} />
          </Routes>
        </div>

        <Footer />
      </div>
    </ScrollWrapper>
      
    </BrowserRouter>
  );
}

export default Router;
